import { Menu as MantineMenu } from '@mantine/core';

export const Menu = MantineMenu.extend({});
